import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { WqSwal as Swal } from "../../utils/themedSwal";
import { WqToast as toast } from "../../utils/themedToast";
import { getEmbedContext, notifyParent } from "../../utils/embed.js";
import { finalizePaymentSuccess, showPaymentError } from "../../utils/paymentOutcomes.js";
import { TransferAccountCard, SubmitBtn } from "./TransferAccountCard.jsx";

const initialMinutes = 30;

export const BankTransferTestMode = ({ transferData }) => {
  const [amount, setAmount] = useState(null);
  const [isExpired, setIsExpired] = useState(false);
  const [time, setTime] = useState(initialMinutes * 60);
  const [accountDetails, setAccountDetails] = useState(null);
  const [validUntil, setValidUntil] = useState(null);
  const refNo =
    sessionStorage.getItem("tranId") ||
    new URLSearchParams(window.location.search).get("_tranId");
  const { isEmbedded } = getEmbedContext();

  useEffect(() => {
    if (!transferData) return;
    const productData = JSON.parse(sessionStorage.getItem("product_data") || "null");
    setAmount(productData?.amount || "");
    const { accountData } = transferData;
    setAccountDetails(accountData);
    setValidUntil(new Date(accountData.validUntil.replace(" ", "T")).getTime());
  }, [transferData]);

  useEffect(() => {
    if (!validUntil) return;
    const tick = () => {
      const diff = Math.floor((validUntil - Date.now()) / 1000);
      if (diff <= 0) {
        setIsExpired(true);
        setTime(0);
      } else {
        setTime(diff);
      }
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [validUntil]);

  const copyToClipboard = () => {
    toast.success("account copied");
    if (accountDetails) navigator.clipboard.writeText(accountDetails.accountNo);
  };

  // No endpoint is ever called here — this is a pure UI simulation.
  const simulateTransfer = () => {
    Swal.fire({
      title: "Simulate transfer outcome",
      text: "This is a test transaction — no real funds move. Pick what you want to simulate.",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Simulate success",
      denyButtonText: "Simulate failure",
      cancelButtonText: "Back",
      confirmButtonColor: "#2e7d32",
      denyButtonColor: "#c0392b",
    }).then((result) => {
      if (result.isConfirmed) {
        finalizePaymentSuccess({
          message: "Test payment simulated successfully",
          refNo,
          isEmbedded,
          notifyExtra: { simulated: true },
        });
      } else if (result.isDenied) {
        showPaymentError(null, "Simulated transfer failure. Please try again.");
        if (isEmbedded) {
            notifyParent("failed", { simulated: true });
          }
      }
    });
  };

  return (
    <TransferAccountCard
      amount={amount}
      accountDetails={accountDetails}
      isExpired={isExpired}
      time={time}
      onCopy={copyToClipboard}
      banner={
        <TestBanner>
          <span>TEST MODE</span> — this transfer is simulated, no funds will move.
        </TestBanner>
      }
    >
      <SubmitBtn type="button" onClick={simulateTransfer} disabled={isExpired}>
        I have completed the transfer
      </SubmitBtn>
    </TransferAccountCard>
  );
};

const TestBanner = styled.div`
  margin: 0 10px 10px;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: #fff4e5;
  color: #9a5b00;
  font-size: 12px;
  text-align: center;
  span {
    font-weight: 700;
  }
`;